module.exports = __webpack_public_path__ + "img/visuel@2x.0788de3d.jpg";